import { Howl, Howler } from "howler";
import { AnimateProgressBar } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/AnimateProgressBar";
import { IToolsState } from "source/app/presentation/Header/Tools/ToolsState";
import Music from "source/app/services/Sound/Music/Music";
import { StartRadioAsync } from "source/app/services/Sound/Radio/RadioStations";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import Background from "source/app/services/UI/Background/Background";
import { State } from "source/app/services/UI/State/State";
import Ambience from "source/app/services/Sound/Ambience/Ambience";
import { IRadioStation } from "motw_core/Entity/IRadioStation";
import { ISoundMasterMenuState } from "source/app/presentation/Header/Tools/Sound/Master/ISoundMasterMenuState";

export default class SoundManager {
    static radioDomain: string = "somafm.com";

    static ToggleMute(): void {
        const ToolsState = State.ReadClass<IToolsState>(
            ESharedComponent.Tools
        ).state;

        const currentMuteState = ToolsState.isMuted;
        const newMuteState = !currentMuteState;
        Howler.mute(newMuteState);
        ToolsState.SetIsMuted(newMuteState);
    }

    static PlayStream(item: IHowlProperties) {
        AnimateProgressBar(true);

        item.html5 = true;
        item.onplay = () => AnimateProgressBar(false);
        item.onplayerror = () => AnimateProgressBar(false);
        item.onloaderror = () => AnimateProgressBar(false);
        var newSound = new Howl(item);
        newSound.play();
        return newSound;
    }

    static GetFileId(entry: string) {
        if (entry === undefined)
            throw new Error("Cannot read the entry: " + entry);

        var entrySignificance = entry.indexOf(" ");

        if (entrySignificance > 3 || entrySignificance < 0)
            throw new Error("Cannot parse the entry: " + entry);

        if (entry.substr(0, 3) === ".:.") return 4;

        return entrySignificance;
    }

    static GetFilePath(soundFileId: number) {
        switch (soundFileId) {
            case 1:
                return "/sounds/Level+.mp3";

            case 2:
                return "/sounds/Level++.mp3";

            case 3:
                return "/sounds/Level+++.mp3";

            case 4:
                return "/sounds/LevelUp.mp3";

            case 5:
                return "/sounds/Coin.mp3";

            case 6:
                return "/sounds/KickDrum.mp3";

            case 7:
                return "/sounds/Welcome.mp3";

            default:
                return "";
        }
    }

    static StopAll() {
        Ambience.Stop();
        Howler.unload();

        State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
            radioStationURL: "",
            radioName: "",
            radioHowl: undefined,
        });
    }

    static async ShuffleEnvironment(radioStation?: IRadioStation) {
        Background.ToggleAnimation();
        SoundManager.StopAll();
        Music.Stop();
        Ambience.StartNextAmbience();
        await StartRadioAsync(radioStation);
    }

    static ToggleEnvironment() {
        const soundMasterMenu = State.ReadClass<ISoundMasterMenuState>(
            ESharedComponent.SoundMasterMenu
        );

        if (!soundMasterMenu) {
            return;
        }

        const { isPlaying } = soundMasterMenu.state;

        if (!isPlaying) {
            Ambience.StartNextAmbience();
            Music.StartNextSong();
            soundMasterMenu.setState({ isPlaying: true });
        } else {
            Music.Stop();
            Ambience.Stop();
            soundMasterMenu.setState({ isPlaying: false });
        }
    }
}
